import {
  IStatisticsResponseModel,
  SystemPerformanceResponseModel,
} from "../models/chart";

import { DEFAULT_STATISTICS_DATE_FORMAT } from "../../system-health/common/values";
import { TimePeriod } from "../../../../../API";
import dayjs from "dayjs";

function convertDatesHelper(
  dates: IStatisticsResponseModel[] | SystemPerformanceResponseModel[],
  timePeriod: TimePeriod
) {
  // if (timePeriod === TimePeriod.ONE_DAY && dates.length) {
  //   return dates.map(el => {
  //     const dateValue =
  //       "date" in el && el.date
  //         ? el.date
  //         : "week_start" in el && el.week_start
  //         ? el.week_start
  //         : undefined;
  //     const date = dateValue ? new Date(dateValue) : new Date();
  //     const hours = date.getHours();
  //     const minutes = date.getMinutes();

  //     return `${hours.toString().padStart(2, "0")}:${minutes
  //       .toString()
  //       .padStart(2, "0")}`;
  //   });
  // }

  return dates.map(el => {
    const dateValue =
      "date" in el && el.date
        ? el.date
        : "week_start" in el && el.week_start
        ? el.week_start
        : undefined;

    return dayjs(dateValue).format(DEFAULT_STATISTICS_DATE_FORMAT);
  });
}

export default convertDatesHelper;
